//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'd2-container-card'
}
